import {useEffect, useState} from 'react'
import {Modal, Button, Form} from 'react-bootstrap'

interface Props {
  show: boolean
  onClose: () => void
  onSave: (text: string) => void
}

export const ModalAddComment: React.FC<Props> = ({show, onClose, onSave}) => {
  const [text, setText] = useState('')

  const handleSave = () => {
    if (!text.trim()) return
    onSave(text.trim())
    setText('')
  }

  useEffect(() => {
    if (!show) setText('')
  }, [show])

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add comment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Comment</Form.Label>
          <Form.Control
            as='textarea'
            rows={4}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder='Enter your comment here'
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='light' onClick={onClose}>
          Cancel
        </Button>
        <Button variant='primary' onClick={() => {handleSave(); onClose()}} disabled={!text.trim()}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
